import type { FC } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => createStyles({
  '@global': {
    '*': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
    },
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      height: '100%',
      width: '100%',
    },
    body: {
      height: '100%',
      width: '100%',
    },
    '#root': {
      height: '100%',
      width: '100%',
    },
    '.zoomin': {
      zoom: '80%',
    },
    '.zoominx2': {
      zoom: '75%',
    },
    '.autocenter': {
      margin: 'auto',
    },
  },
}),);

const GlobalStyles: FC = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
